// src/config.ts
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/orion/api';

export const apiUrl = (path: string) => {
  const base = API_BASE_URL.replace(/\/+$/, '');
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${base}${p}`;
};

// Lista de rutas posibles (orden importa). Puedes sobreescribirla en window.__APP_CONFIG__
const PATHS =
  (typeof window !== 'undefined' && (window as any).__APP_CONFIG__?.WEBHOOK_WEB_PATHS) ||
  ['/webhooks/web-webhook', '/webhooks/web-chat'];

export const WEBHOOK_WEB_LIST = PATHS.map(apiUrl);
export const WEBHOOK_WEB = WEBHOOK_WEB_LIST[0];